import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import {
  VAIconRegistryService,
  close,
  exclamationTriangle,
} from "@va/core-library/icons";
import { NzModalRef } from "ng-zorro-antd/modal";
import {
  ACTION_BTN_DETAILS,
  DUPLICATE_NAME_ERROR_MSG,
  EXIT_WITHOUT_SAVE_MSG,
} from "../constants";
import { ComparativeAnalysisService } from "../comparative-analysis.service";

@Component({
  selector: "app-common-action-modal",
  templateUrl: "./common-action-modal.component.html",
  styleUrls: ["./common-action-modal.component.scss"],
})
export class CommonActionModalComponent {
  @Input() actionDetailObj;
  @Input() onSaveAsOrDeleteClick;
  @Input() onExitWithoutSavingClick;
  @ViewChild("templateInput") nameField: ElementRef;

  actionButton: string;
  templateName: string;
  templateId;
  actionButtonList = ACTION_BTN_DETAILS;
  duplicateErrorMsg = DUPLICATE_NAME_ERROR_MSG;
  exitWithoutSavingMsg = EXIT_WITHOUT_SAVE_MSG;
  isDuplicateName: boolean = false;
  isCurrentAnalysisSaved: boolean = false;

  constructor(
    private modal: NzModalRef,
    private iconRegistry: VAIconRegistryService,
    private dataService: ComparativeAnalysisService,
  ) {
    this.iconRegistry.registerIcons([close, exclamationTriangle]);
  }

  ngOnInit(): void {
    this.isCurrentAnalysisSaved = false;
    this.actionButton = this.actionDetailObj["action_type"];
    this.templateName = this.actionDetailObj["template_name"];
    this.templateId = this.actionDetailObj["template_id"];
    if (this.actionButton === "delete") {
      this.actionButtonList[this.actionButton]["content_header"] =
        `Are you sure you want to delete "${this.templateName}" Custom Analysis? It will be permanently deleted.`;
    } else if (this.actionButton === "exit_without_saving") {
      this.isCurrentAnalysisSaved = true;
    }
  }

  destroyModal() {
    this.modal.destroy();
    if (this.actionButton === "exit_without_saving") {
      this.dataService.updateLeftPanel(false);
    }
  }
}
